import React, { createContext, useRef, useState } from 'react'

type ReportIssueDataType = {
  getInformation?: () => { [key: string]: any }
  labels?: string[]
} | null

const ReportIssueContext = createContext({
  issueData: { current: null as ReportIssueDataType },
  setReportIssueData: (data: ReportIssueDataType) => {},
  isOpen: false,
  setIsOpen: (isOpen: boolean) => {},
  openReportIssue: () => {},
})

export const ReportIssueProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const issueData = useRef<ReportIssueDataType>(null)

  const setReportIssueData = (data: ReportIssueDataType) => {
    issueData.current = data
  }

  const openReportIssue = () => {
    setIsOpen(true)
  }

  return (
    <ReportIssueContext.Provider
      value={{
        isOpen,
        issueData,
        setReportIssueData,
        setIsOpen,
        openReportIssue,
      }}
    >
      {children}
    </ReportIssueContext.Provider>
  )
}

export const useReportIssueContext = () => React.useContext(ReportIssueContext)

// Function to set the issue data as a hook
export const useReportIssue = (data: ReportIssueDataType) => {
  const { setReportIssueData } = React.useContext(ReportIssueContext)

  React.useEffect(() => {
    setReportIssueData(data)
    return () => {
      setReportIssueData(null)
    }
  }, [data, setReportIssueData])
}

export default ReportIssueContext
